/** @format */

import React, { useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Listas from "../components/ui/Listas";

import { Container } from "@material-ui/core";

import NavBar from "../components/ui/NavBar";

import { Route, Switch } from "react-router-dom";

import FormInfoCom from "../components/Consultainforme/FormInfoCom";
import RegistroConsultaTest from "../components/administracion/RegistroConsultaTest";
import Soporte from "../components/soporte/Soporte";
import ViewInforme from "../components/Consultainforme/ViewInforme";
import VerificacionTest from "../components/verificacioncheques/VerificacionTest";
import InfoVerificacionTest from "../components/verificacioncheques/InfoVerificacionTest";

import { AuthContext } from "../context/Globales/AuthContext";
import { types } from "../context/types";

import PrincipalSaldo from "../components/SaldoPrepago/PrincipalSaldo";
import { DecodificanString } from "../helpers/Codifican";

import { isBrowser, isMobile } from "react-device-detect";
import MenuMobile from "../components/ui/MenuMobile";

//Configuraciones del sitio
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar, // alinea la linea del sidebar con la del navbar
  },
  contentMovile: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  contentaDesktop: {
    display: "flex",
    padding: theme.spacing(9),
  },
}));

const MiniDrawer = () => {
  const { dispatch } = useContext(AuthContext);
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  //const MSG  = mensajeglobales(); // mensaje globales;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <CssBaseline />

      {!DecodificanString(JSON.parse(localStorage.getItem("autenticado"))) ? (
        dispatch({
          type: types.AuthLogout,
        })
      ) : (
        <>
          <div className={classes.root}>
            <NavBar handleDrawerOpen={handleDrawerOpen} open={open} />
            {!isMobile ? (
              <Listas open={open} handleDrawerClose={handleDrawerClose} />
            ) : (
              " "
            )}
          </div>
          <div>
            <Switch>
              <React.Fragment>
                <main
                  className={
                    isMobile ? classes.contentMovile : classes.contentaDesktop
                  }
                > 
                  <Route exact path="/" />
                  <Route path="/informe" component={FormInfoCom} />
                  {/* <Route exact path="multinfo" component={ FormMultiplesRut }/>*/}
                  <Route path="/log" component={RegistroConsultaTest} />
                  <Route path="/soporte" component={Soporte} />
                  <Route path="/informeonp" component={VerificacionTest} />
                  <Route
                    path="/informeComercial-result"
                    component={ViewInforme}
                  />
                  <Route
                    path="/verificacioncheque-result"
                    component={InfoVerificacionTest}
                  />
                  <Route path="/viewsaldo" component={PrincipalSaldo} />
                  <Route path="/MenuMobile" component={MenuMobile} />
                  {/*<Route  component={NotFound} />*/}
                  {/*Aqui podria colocar un msj de bienvenida ¿?*/}

                  {/*SI NO ENCUENTRA UNA RUTA SE REDICCIONARA AL INFORMECOMERCIAL!!! */}
                  {/* */}
                </main>
              </React.Fragment>
            </Switch>
          </div>{" "}
        </>
      )}
    </>
  );
};
export default MiniDrawer;
